import { createAsyncThunk } from '@reduxjs/toolkit'
import * as api from '@/apis/aipass'
import type { ReportFormType } from './report-manager-slice'
import { env } from '@/libs/env'
import { ExportHistory } from '@/models/report'
import type { RootState } from '../store'

export const fetchReportHistory = createAsyncThunk(
  'reportManager/fetchReportHistory',
  async () => {
    return api
      .http<ExportHistory[]>({
        method: 'get',
        url: `${env('BASE_API_V3')}/sales-manager/report/histories`,
      })
      .then(results => results.data)
      .catch(e => {
        console.error(e)
        return []
      })
  },
  {
    dispatchConditionRejection: true,
    condition: (arg, { getState }) => {
      const { reportManager } = getState() as RootState
      return !reportManager.isFetching
    },
  },
)
export const exportReportAsync = createAsyncThunk('reportManager/exportReportAsync', async (formValue: ReportFormType) => {
  await api.http({
    method: 'post',
    url: `${env('BASE_API_V3')}/sales-manager/report`,
    data: formValue,
  })
})
